import api from '../../utils/api'
import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormStockItem from './form/FormStockItem'

function EditStockItem({ id, btCancelAction, handleOnSuccess }) {
    const [item, setItem] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get(`/stock/general/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            setItem(response.data.item)
        })
    }, [token, id])

    async function updateItem(item) {
        let msgType = 'success'

        const data = await api.patch(`/stock/general/${item._id}`, item, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => response.data)
            .catch((err) => { msgType = 'error'; return err.response.data })

        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        item.name && (
            <FormStockItem title="Editar Item de Estoque" handleSubmit={updateItem} btnText="Salvar" btCancelAction={btCancelAction} itemData={item} />
        )
    )
}

export default EditStockItem
